// extracted by mini-css-extract-plugin
module.exports = {"modal":"ShareModal_modal__3fB0d","button":"ShareModal_button__1Ni7T","delete":"ShareModal_delete__2eHCS"};